import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import BlogForm from '../../../../components/forms/BlogForm/BlogForm';

const AddNewBlog = () => {
    return (
        <Container fluid>
            <div className='mt-5 mb-5'>
                <h3>Add New News</h3>
            </div>
            <Row>
                <Col md={4}>
                    <h5>Add the latest news</h5>
                    <p>Post the latest news about Najeeb Auto.</p>
                </Col>

                <Col md={8}>
                    <BlogForm />
                </Col>
            </Row>
        </Container>
    );
};

export default AddNewBlog;
